/** Loads the lazy local chunk (engine + cards) once. */
import type * as Local from '../local';

export type LocalModule = typeof Local;

let mod: Promise<LocalModule> | null = null;

/** The local chunk (sandbox, replays, coverage). */
export function loadLocal(): Promise<LocalModule> {
  mod ??= import('../local');
  return mod;
}
